import { Controller } from "stimulus";

export default class ShowController extends Controller {
  static targets = ["videoContainer"];

  loadEpisode(event) {
    // Don't load the episode if there is no audio URL
    if (!this.audioUrlValue) {
      return;
    }

    event.preventDefault();

    const audioPlayer = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-audio-player]'),
      'media--audio-player'
    );
    const timestamp = parseInt(event.target.getAttribute('data-timestamp'));

    audioPlayer.loadEpisode({
      itemId: this.episodeIdValue,
      itemType: "Episode",
      audioUrl: this.audioUrlValue,
      timestamp: timestamp
    });
  }

  openComments(event) {
    let maxTop = 300;

    if (this.hasVideoContainerTarget) {
      const videoContainer = this.videoContainerTarget;
      const videoContainerRect = videoContainer.getBoundingClientRect();
      maxTop = videoContainerRect.bottom + window.scrollY;
    }

    event.preventDefault();
    this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-comments-drawer] [data-controller="drawer"]'),
      'drawer'
    ).open({height: window.innerHeight - maxTop});
  }
}

ShowController.values = { episodeId: Number, audioUrl: String };